import { t } from "@lingui/macro";
import React from "react";

import {
  Text,
  HStack,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { AgendaItemContainer } from "../AgendaItemContainer";

type RequestAvailableCardProps = {
  durationMins: number;
  onPress: () => void;
};

export const RequestAvailableCard = ({
  durationMins,
  onPress,
}: RequestAvailableCardProps) => {
  return (
    <AgendaItemContainer durationMins={durationMins}>
      <Pressable onPress={onPress} width="100%" height="100%">
        <HStack
          bg="surface-user-selectable-colorC-subtlest"
          height="100%"
          width="100%"
          borderRadius="2"
          p={4}
          alignItems="center"
        >
          <Text
            maxFontSizeMultiplier={2}
            variant="mainSmallSemiBold"
            color="text-user-selectable-colorC"
          >
            {t`Request Available`}
          </Text>
        </HStack>
      </Pressable>
    </AgendaItemContainer>
  );
};
